import { render, staticRenderFns } from "./JsonViewer.vue?vue&type=template&id=19d293c8&scoped=true&"
import script from "./JsonViewer.vue?vue&type=script&lang=ts&"
export * from "./JsonViewer.vue?vue&type=script&lang=ts&"
import style0 from "./JsonViewer.vue?vue&type=style&index=0&id=19d293c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d293c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
